<script lang='ts' setup>
import * as echarts from 'echarts/core.js'
import {
  BarChart,
  LineChart,
} from 'echarts/charts.js'
import {
  DatasetComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  TransformComponent,

  VisualMapComponent,
} from 'echarts/components.js'
import { LabelLayout, UniversalTransition } from 'echarts/features.js'
import { CanvasRenderer } from 'echarts/renderers.js'
import type {
  // 系列类型的定义后缀都为 SeriesOption
  BarSeriesOption,
  LineSeriesOption,
} from 'echarts/charts.js'

import type {
  DatasetComponentOption,
  GridComponentOption,
  TitleComponentOption,
  TooltipComponentOption,
} from 'echarts/components'
import { getLast30Days } from '@qctsw/utils'
import { getCollectiveStats } from '~/server'

export type ECOption = echarts.ComposeOption<
  | BarSeriesOption
  | LineSeriesOption
  | TitleComponentOption
  | TooltipComponentOption
  | GridComponentOption
  | DatasetComponentOption
>

const props = withDefaults(defineProps<{
  id: string | number
}>(), {

})
echarts.use([
  VisualMapComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  LineChart,
  ToolboxComponent,
])

const { data } = await getCollectiveStats(props.id)
data.reverse()
// const datesObj = data.reduce((pre: Record<string, number>, next) => {
//   pre[next.date] = next.total
//   return pre
// }, {})

// const dates = getLast30Days()

const option = computed<ECOption>(() => ({
  title: {
    text: '最新集体投诉统计',
  },

  tooltip: {
    trigger: 'item',
    show: true,
    formatter: '日期 ：{b0} <br/> 宗数 ：{c0}',

  },

  legend: {
    // data: ['投诉量'],
    selectedMode: 'single',
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true,
  },
  xAxis: {
    type: 'category',
    data: data.map(i => i.date),
    axisLabel: {
      showMaxLabel: true,
      showMinLabel: true,
    },

  },
  yAxis: {
    minInterval: 1,
    type: 'value',

  },
  series: [
    {

      type: 'line',
      stack: 'Total',

      data: data.map(i => i.total),
    },
  ],
}))
const mainChartRef = ref()
onMounted(() => {
  if (data.length) {
    mainChartRef.value = echarts.init(mainChartRef.value)
    mainChartRef.value.setOption(option.value)
  }
})
</script>

<template>
  <div v-if="data.length" ref="mainChartRef" class="chart-main my-3 p-3 border-1 border-slate-2 rounded-md" />
</template>

<style lang='scss' scoped>
.chart-main {
  width: 100%;
  height: 340px;
}
</style>
